import { outlinedInputClasses, styled } from '@mui/material';
import Input from '../input';
import { Props } from './types';

const StyledTextarea = styled(Input)<Pick<Props, 'resize'>>(
  ({ theme, resize }) => ({
    background: theme.palette.background.active,
    padding: theme.spacing(1.5),
    [`.${outlinedInputClasses.focused}`]: {
      borderColor: 'red!important',
    },
    [`&.${outlinedInputClasses.multiline}`]: {
      resize,
      width: '100%',
      padding: theme.spacing(1.5, 2),
      fontSize: theme.typography.textSm.fontSize,
      lineHeight: theme.typography.textSm.lineHeight,
      fontFamily: theme.typography.fontFamily,
      borderRadius: theme.shape.borderRadius * 3,
      color: theme.palette.text.placeholder,
      '&:not(empty)': {
        color: theme.palette.text.primary,
      },
      '&:focus-visible': {
        outline: 0,
      },
    },
  }),
);

export default StyledTextarea;
